<template>
  <div>
    <div>
      <div class="summary-data-options">
        <b-row class="data-line thead">
          <b-col md="" sm="" class="data-cell first">
            <slot name="txtTariffOptionsHeader">Ausgewählte Tarifoptionen</slot>
          </b-col>
          <b-col md="" sm="" class="data-cell second">
            <slot name="txtCosts">Kosten</slot>
          </b-col>
          <b-col md="" sm="" class="data-cell third">
            <slot name="txtLink"><a @click.prevent="goToTariffOptionsStep()" class="linkChange">ändern</a></slot>
            <slot name="txtRuntime">Laufzeit</slot>
          </b-col>
        </b-row>
      </div>
      <TariffOptionsSummary :tariff-options="savedTariffOptions">
        <template #txtSum><slot name="txtSumWrapper"></slot></template>
      </TariffOptionsSummary>
    </div>
    <div class="data-line indication">
      <slot name="txtPaymentTariffOptions">
        <p>Die Bezahlung Ihrer Tarifoptionen erfolgt automatisch über Ihr  mobil Prepaid Guthaben.</p>
        <p>
          <strong>
            Hinweis: Bitte beachten Sie, dass der Betrag für die ausgewählten Tarifoptionen von Ihrem
            mobil Guthabenkonto abgebucht wird. Laden Sie daher bitte Ihr Guthaben auf,
            damit die Optionen aktiviert werden.
          </strong>
        </p>
      </slot>
    </div>
  </div>
</template>
<script>
import TariffOptionsSummary from '../Summary/TariffOptionsSummary.vue'
import { mapGetters, mapMutations } from 'vuex'
import { stepName as tariffOptionsStep } from '../Tariff/TariffOptions.vue'

export default {
  name: 'TariffOptionsSummaryWrapper',
  components: {
    TariffOptionsSummary
  },
  computed: {
    ...mapGetters('activation/tariffOptions', [
      'savedTariffOptions'
    ])
  },
  methods: {
    goToTariffOptionsStep: function () {
      this.goToStep(tariffOptionsStep)
    },
    ...mapMutations('activation', [
      'goToStep'
    ])
  }
}
</script>
